
import React, { useState } from 'react';
import banner1 from '../assets/images/airforce-img.jpg';
import banner2 from '../assets/images/airforce-img.jpg';
import banner3 from '../assets/images/airforce-img.jpg';
import aboutUs from "../assets/images/about-us.avif"
import HomeGallery from './HomeGallery';
import AcademicPlannerPDF from "../assets/pdf/Academic-Planner.pdf";
import Testimonials from './Testimonials';
import WhyChooseSection from './WhyChooseSection';
import AcademicEvents from './AcademicEvents';
import LearningPhilosophy from './LearningPhilosophy';
const Home = () => {

  const [activeTab, setActiveTab] = useState('nurturing');

  const image = (name) => `/assets/images/${name}`;

  const admissionCards = [
    {
      icon: 'bi-mortarboard-fill',
      status: '2026-27',
      title: 'Admission Open',
      link: '/admission-form',
      color: 'dock-card-cyan'
    },
    {
      icon: 'bi-calendar-check',
      status: 'Academic',
      title: 'Academic Planner',
      link: AcademicPlannerPDF,
      color: 'dock-card-blue'
    },
    {
      icon: 'bi-pencil-square',
      status: 'All Couses',
      title: 'Details of Courses',
      link: '/courses',
      color: 'dock-card-teal'
    },
    {
      icon: 'bi-trophy-fill',
      status: 'Notice',
      title: 'Admission Notice',
      link: '#statsSection',
      color: 'dock-card-purple'
    }
  ];

  const features = {
    nurturing: {
      badge: 'All Courses ',
      title: 'Education That Builds Strong Foundations',
      description:
        "Air Force School, Vayu Sena Nagar, Nagpur, provides quality education from Kindergarten to Class X, following the curriculum prescribed by the Central Board of Secondary Education (CBSE).",
      features: [
        {
          title: 'Kindergarten (LKG & UKG)',
          description:
            'The pre-primary programme focuses on foundational learning through play-based and activity-oriented methods. Children develop language skills, early numeracy, creativity, social interaction, and good habits in a joyful learning environment.'
        },
        {
          title: 'Primary Stage (Classes I – V)',
          description:
            'The primary curriculum emphasises literacy, numeracy, communication, creativity, and conceptual understanding through engaging classroom activities.'
        },
        {
          title: 'Middle Stage (Classes VI – VIII)',
          description:
            'Students strengthen their subject knowledge, critical thinking, problem-solving abilities, and practical understanding through structured learning experiences.'
        },
        {
          title: 'Secondary Stage (Classes IX – X)',
          description:
            'The primary curriculum emphasises literacy, numeracy, communication, creativity, and conceptual understanding through engaging classroom activities.The secondary curriculum focuses on academic excellence, analytical thinking, and preparation for the CBSE Class X Board Examination.'
        }
      ],
      image: 'Nurturing-Learners-1.jpg',
      icon: 'bi-heart-pulse-fill',
      badgeTitle: 'NABET & IDS Accredited',
      badgeText: 'Highest Standards of Learning',
      button: 'Explore About School',
      link: '#aboutSectionDetail'
    },

    methodology: {
      badge: 'Academic Rigor',
      title: 'Methodology',
      description:
        'Practising an innovative system of imparting knowledge enriched with experimental examples, interactive STEM labs, digital classrooms, and inquiry-based learning that inspire students to think critically and solve real-world problems.',
      features: [
        {
          title: 'Creative Study Pattern',
          description:
            'Empowering independent thinkers capable of articulating original viewpoints.'
        },
        {
          title: 'Provided with Experimental Examples',
          description:
            'Advanced Physics, Chemistry, Biology & Computer Laboratories.'
        }
      ],
      image: 'METHODOLOGY1.jpg',
      icon: 'bi-lightbulb-fill',
      badgeTitle: 'STEM & Robotics',
      badgeText: 'Experiential 21st-Century Learning',
      button: 'Contact Academic Desk',
      link: '#contactSection'
    },

    beyond: {
      badge: 'Holistic Growth',
      title: 'Beyond Classroom',
      description:
        'We, at Bharatiya Vidya Bhavan, help our students engage in collaborative learning opportunities. From industrial visits to IIM Nagpur to cultural and sports competitions, education extends beyond textbook walls to sculpt well-rounded personalities.',
      features: [
        {
          title: 'Creative Study Pattern',
          description:
            'Leadership training through Scouts & Guides, NCC, and Student Council.'
        },
        {
          title: 'Provided with Experimental Examples',
          description:
            'Industrial tours, social outreach, and prestigious national competitions.'
        }
      ],
      image: 'BEYOND_CLASSROOM_1.jpg',
      icon: 'bi-compass-fill',
      badgeTitle: '130+ Active Clubs',
      badgeText: 'Arts, Sports, Music & Debates',
      button: 'View Campus Events',
      link: '#calendarEventsSection'
    }
  };

const statistics = [
  {
    icon: 'bi-people-fill',
    number: '2275+',
    title: 'Enrolled Students'
  },
  {
    icon: 'bi-trophy-fill',
    number: '600+',
    title: 'Distinction & Merits'
  },
  {
    icon: 'bi-stars',
    number: '130+',
    title: 'Co-Curricular Activities'
  },
  {
    icon: 'bi-person-workspace',
    number: '120+',
    title: 'Dedicated Educators'
  }
];

  const events = [
    {
      image: 'img3.jpg',
      date: '27th Aug 2026',
      category: 'Eco-Art',
      icon: 'bi-flower1',
      title: 'Eco-Friendly Clay Ganesh Making Activity',
      description:
        'Today, our school witnessed a beautiful blend of devotion, clay, and fun!',
      highlight: 'Std. I to X • 350+ Student Sculptors'
    },
    {
      image: '1.jpeg',
      date: '27th Aug 2026',
      category: 'Leadership',
      icon: 'bi-shield-check',
      title: 'Investiture Ceremony — Bharat Scouts & Guides',
      description:
        'A proud and memorable day as our Std. VI students formally began their journey as members of the Scouts and Guides movement.',
      highlight: 'Std. VI Troop • Formal Scarfing'
    },
    {
      image: 'METHODOLOGY3.jpg',
      date: '25th Aug 2026',
      category: 'Career Mastery',
      icon: 'bi-compass',
      title: 'Exploring Careers Beyond the Classroom!',
      description:
        'An academic exposure experience connecting classroom learning with career opportunities.',
      highlight: 'Educational Exposure • IIM Nagpur'
    }
  ];

  const activeFeature = features[activeTab];

  return (
    <main>

      {/* ================= HERO SLIDER ================= */}

      <section className="hero-slider-section">

        <div
          id="mainHeroCarousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
          data-bs-interval="5000"
        >

          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#mainHeroCarousel"
              data-bs-slide-to="0"
              className="active"
              aria-label="Slide 1"
            />

            <button
              type="button"
              data-bs-target="#mainHeroCarousel"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            />

            <button
              type="button"
              data-bs-target="#mainHeroCarousel"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            />
          </div>

          <div className="carousel-inner">

            {/* SLIDE 1 */}

            <div
              className="carousel-item active hero-carousel-item"
              style={{
                 backgroundImage: `url(${banner1})`
              }}
            >

              <div className="hero-overlay">

                <div className="container hero-con">

                  <div className="hero-caption-card">

                    <span className="hero-badge-pill">
                      <i className="bi bi-stars"></i>
                      Welcome to Airforce
                    </span>

                    <h1 className="hero-title-main">
                      Explore, Engage
                      <span className="hero-text-accent">
                        {' '}& Empower
                      </span>
                    </h1>

                    <p className="hero-description">
                      Get set to change the way you look at schools.
                    </p>

                    <div className="d-flex flex-wrap gap-3">

                      <a
                        href="https://entab.online/BVMTRM"
                        target="_blank"
                        rel="noreferrer"
                        className="btn hero-btn-primary"
                      >
                        <i className="bi bi-pencil-fill"></i>
                        Apply For Admission
                      </a>

                      <a
                        href="#whyChooseSection"
                        className="btn hero-btn-secondary"
                      >
                        <i className="bi bi-compass"></i>
                        Why Choose Bhavan's
                      </a>

                    </div>

                  </div>

                </div>

              </div>

            </div>

            {/* SLIDE 2 */}

            <div
              className="carousel-item hero-carousel-item"
              style={{
                backgroundImage: `url(${banner2})`
                }}
            >

              <div className="hero-overlay">

                <div className="container ">

                  <div className="hero-caption-card">

                    <span className="hero-badge-pill">
                      <i className="bi bi-mortarboard-fill"></i>
                      Holistic Development
                    </span>

                    <h2 className="hero-title-main">
                      Sculpting
                      <span className="hero-text-accent">
                        {' '}Young Learners
                      </span>
                    </h2>

                    <p className="hero-description">
                      Encouraging independence of views and the
                      strong conviction to stand by those.
                    </p>

                    <div className="d-flex flex-wrap gap-3">

                      <a
                        href="#whyChooseSection"
                        className="btn hero-btn-primary"
                      >
                        <i className="bi bi-award-fill"></i>
                        Our Methodology
                      </a>

                      <a
                        href="#calendarEventsSection"
                        className="btn hero-btn-secondary"
                      >
                        <i className="bi bi-camera-reels"></i>
                        Campus Highlights
                      </a>

                    </div>

                  </div>

                </div>

              </div>

            </div>

            {/* SLIDE 3 */}

            <div
              className="carousel-item hero-carousel-item"
             style={{
                backgroundImage: `url(${banner3})`
                }}
            >

              <div className="hero-overlay">

                <div className="container ">

                  <div className="hero-caption-card">

                    <span className="hero-badge-pill">
                      <i className="bi bi-lightbulb-fill"></i>
                      21st Century Education
                    </span>

                    <h2 className="hero-title-main">
                      Nurturing a
                      <span className="hero-text-accent">
                        {' '}Progressive Mindset
                      </span>
                    </h2>

                    <p className="hero-description">
                      Practising an innovative system of imparting knowledge.
                    </p>

                    <a
                      href="https://entab.online/BVMTRM"
                      target="_blank"
                      rel="noreferrer"
                      className="btn hero-btn-primary"
                    >
                      <i className="bi bi-journal-check"></i>
                      Admissions Inquiry
                    </a>

                  </div>

                </div>

              </div>

            </div>

          </div>

         {/* BOTTOM RIGHT SLIDER CONTROLS */}
<div className="hero-slider-controls">

  <button
    className="hero-slider-arrow"
    type="button"
    data-bs-target="#mainHeroCarousel"
    data-bs-slide="prev"
    aria-label="Previous slide"
  >
    <i className="bi bi-arrow-left"></i>
  </button>

  <button
    className="hero-slider-arrow"
    type="button"
    data-bs-target="#mainHeroCarousel"
    data-bs-slide="next"
    aria-label="Next slide"
  >
    <i className="bi bi-arrow-right"></i>
  </button>

</div>
        </div>

      </section>


      {/* ================= ADMISSION CARDS ================= */}

      <section className="floating-dock-wrapper ">

        <div className="container-fluid p-3 pt-0">

          <div className="row g-3">

            {admissionCards.map((card, index) => (

              <div className="col-lg-3 col-sm-6" key={index}>

                <a
                  href={card.link}
                  target={card.link.startsWith('http') ? '_blank' : undefined}
                  rel={card.link.startsWith('http') ? 'noreferrer' : undefined}
                  className={`dock-card ${card.color}`}
                >

                  <div className="dock-icon-box">
                    <i className={`bi ${card.icon}`}></i>
                  </div>

                  <div className="dock-content">

                    <span className="dock-status-tag">
                      {card.status}
                    </span>

                    <h4 className="dock-title">
                      {card.title}
                    </h4>

                  </div>

                  <i className="bi bi-arrow-right dock-arrow"></i>

                </a>

              </div>

            ))}

          </div>

        </div>

      </section>

      {/* ================= HERITAGE SHOWCASE ================= */}

      <section
        className="cultural-feature-wrapper mb-0 mt-0 pt-0 pb-2"
        id="culturalKendraSection"
        style={{background:"linear-gradient(135deg, #000000 0%, #000000 100%)"}}
      >

        <div className="container ">

          <div className="cultural-banner-box">

            <div className="row align-items-center g-5">

              <div className="col-lg-7">

                <span className="badge bg-warning text-dark px-3 py-2 fw-bold text-uppercase mb-3">
                Welcome to AirForce School
                </span>

                <h2 className="text-white fw-bold mb-3 display-6">
                  Shaping young minds through education, discipline and values.
                </h2>

                <p className="text-light mb-4" style={{ lineHeight: 1.8, opacity: 0.9 }}>
                  Air Force School, Vayu Sena Nagar, Nagpur, was established in 1968 with the aim of providing quality education through a broad, balanced, and relevant curriculum. Affiliated with the Central Board of Secondary Education (CBSE), the school caters to students from LKG to Class X. We strive to nurture academic excellence, discipline, creativity, and strong moral values among our students. Our focus is on providing a supportive learning environment that encourages critical thinking, holistic development, and lifelong learning. We aim to empower students with the knowledge, skills, and confidence needed to become responsible citizens and contribute positively to society.
                </p>

                <div className="d-flex flex-wrap gap-3">

                  <a
                    href="#"
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-warning fw-bold px-4 py-3 rounded-pill shadow"
                  >
                    <i className="bi bi-ticket-perforated-fill me-1"></i>
                    Book Your Visit 
                  </a>

                  <a
                    href="https://www.google.com/maps/place/Air+Force+School,+Vayusena+Nagar/@21.1601624,79.0391492,17z/data=!3m1!4b1!4m6!3m5!1s0x3bd4c035f7973a8b:0x577c9730315394e5!8m2!3d21.1601574!4d79.0417241!16s%2Fg%2F1vr1v32h?entry=ttu&g_ep=EgoyMDI2MTAyOC4wIKXMDSoASAFQAw%3D%3D"
                    target='_blank'
                    className="btn btn-outline-light px-4 py-3 rounded-pill"
                  >
                    <i className="bi bi-geo-alt me-1"></i>
                    Visit Campus
                  </a>

                </div>

              </div>

              <div className="col-lg-5 text-center">

                <img
                  src={aboutUs}
                  alt="Koradi Sanskritik Kendra Pictorial Exhibition"
                  className="cultural-banner-img"
                />

              </div>

            </div>

          </div>

        </div>

      </section>

      <section className="courses-section" id="courses">
  <div className="container">

    <div className="courses-heading">
      <h2>Explore Our <span>Courses</span></h2>
      <p>
        A well-structured learning journey designed to nurture young minds
        at every stage of their educational development.
      </p>
    </div>

    <div className="courses-grid">

      <div className="course-card">
        <div className="course-icon kindergarten">
          <i className="bi bi-puzzle-fill"></i>
        </div>
        <h3>Kindergarten</h3>
        <span className="class-label">LKG & UKG</span>
        <p>
          The pre-primary programme focuses on foundational learning
          through play-based and activity-oriented methods. Children
          develop language skills, early numeracy, creativity, social
          interaction, and good habits in a joyful learning environment.
        </p>
      </div>

      <div className="course-card">
        <div className="course-icon primary">
          <i className="bi bi-book-half"></i>
        </div>
        <h3>Primary Stage</h3>
        <span className="class-label">Classes I – V</span>
        <p>
          The primary curriculum emphasises literacy, numeracy,
          communication, creativity, and conceptual understanding
          through engaging classroom activities.
        </p>
      </div>

      <div className="course-card">
        <div className="course-icon middle">
          <i className="bi bi-lightbulb-fill"></i>
        </div>
        <h3>Middle Stage</h3>
        <span className="class-label">Classes VI – VIII</span>
        <p>
          Students strengthen their subject knowledge, critical thinking,
          problem-solving abilities, and practical understanding through
          structured learning experiences.
        </p>
      </div>

      <div className="course-card">
        <div className="course-icon secondary">
          <i className="bi bi-mortarboard-fill"></i>
        </div>
        <h3>Secondary Stage</h3>
        <span className="class-label">Classes IX – X</span>
        <p>
          The secondary curriculum focuses on academic excellence,
          analytical thinking, and preparation for the CBSE Class X
          Board Examination.
        </p>
      </div>

    </div>
  </div>
</section>

            <WhyChooseSection/>

      <HomeGallery/>
       <AcademicEvents/>
             <LearningPhilosophy/>


    </main>
  );
};

export default Home;
